/* zw-pdp-gallery.js — contatore "1 / 4" della galleria a scorrimento orizzontale (sotto i
   1200px) per gallery_type = static_column_aside. Vedi assets/zw-pdp-gallery.css. */
(function () {
  const init = () => {
    document.querySelectorAll('.product__outer--static-column-aside .product__media-wrapper').forEach((wrap) => {
      if (wrap.dataset.zwGallery) return;
      const list = wrap.querySelector('.product__media-list');
      if (!list) return;
      const visible = () => Array.from(list.querySelectorAll('.product__media-item')).filter((i) => !i.hidden);
      if (visible().length < 2 && list.querySelectorAll('.product__media-item').length < 2) return;
      wrap.dataset.zwGallery = '1';
      const counter = document.createElement('div');
      counter.className = 'zw-gallery__counter';
      counter.setAttribute('aria-live', 'polite');
      wrap.appendChild(counter);
      const update = () => {
        const items = visible();
        const w = list.clientWidth || 1;
        const idx = Math.min(items.length, Math.max(1, Math.round(list.scrollLeft / w) + 1));
        counter.textContent = `${idx} / ${items.length}`;
        counter.hidden = items.length < 2;
      };
      document.addEventListener('zw:gallery:filter', update);
      let raf = null;
      list.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          update();
        });
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };
  // miniature (thumbs_aside, da 900px): colonna a scorrimento nativo (CSS in zw-pdp-gallery.css).
  // Lo slider verticale del tema resta istanziato ma non trasla (CSS) e non prende il dito
  // (allowTouchMove = false, altrimenti blocca lo scorrimento a dito su tablet): qui click,
  // foto attiva, frecce su/giu' e sfumature. La colonna si sposta da sola SOLO quando la foto
  // cambia da fuori (frecce, tastiera, varianti), mai per un hover o un click sulle miniature:
  // spostarla sotto il cursore faceva scivolare la colonna una miniatura dopo l'altra.
  const initThumbs = () => {
    document.querySelectorAll('.product__outer--thumbs-aside .product__media-sublist-outer').forEach((outer) => {
      if (outer.dataset.zwThumbs) return;
      const list = outer.querySelector('.js-media-sublist, .product__media-sublist');
      const main = outer.closest('.product__outer').querySelector('.js-media-list');
      if (!list || !main) return;
      outer.dataset.zwThumbs = '1';
      const wide = () => window.matchMedia('(min-width: 900px)').matches;
      const mk = (dir, label) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = `zw-thumbs__btn zw-thumbs__btn--${dir}`;
        b.setAttribute('aria-label', label || '');
        b.addEventListener('click', () => {
          list.scrollBy({ top: (dir === 'up' ? -1 : 1) * list.clientHeight * 0.75, behavior: 'smooth' });
        });
        outer.appendChild(b);
        return b;
      };
      mk('up', outer.dataset.zwUp);
      mk('down', outer.dataset.zwDown);
      const sync = () => {
        const max = list.scrollHeight - list.clientHeight;
        const on = wide() && max > 2;
        outer.classList.toggle('can-up', on && list.scrollTop > 2);
        outer.classList.toggle('can-down', on && list.scrollTop < max - 2);
      };
      let raf = null;
      list.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { raf = null; sync(); });
      }, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(sync).observe(list);
      window.addEventListener('load', sync);
      // foto attiva: bordo sulla miniatura; se la foto e' cambiata da fuori, la miniatura entra in vista
      let fromThumb = false;
      const items = () => Array.from(list.querySelectorAll('.product__media-subitem'));
      const mark = () => {
        const sw = main.swiper;
        const slide = sw && sw.slides[sw.activeIndex];
        const key = slide && slide.dataset.mediaId;
        let cur = null;
        items().forEach((t) => {
          const on = !!key && t.dataset.mediaSubId === key;
          t.classList.toggle('is-active', on);
          if (on) cur = t;
        });
        if (cur && !fromThumb && wide()) {
          // posizione nella colonna (rect + scrollTop: offsetTop dipende da chi e' posizionato)
          const top = cur.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
          const bottom = top + cur.offsetHeight;
          if (top < list.scrollTop) list.scrollTo({ top: top - 12, behavior: 'smooth' });
          else if (bottom > list.scrollTop + list.clientHeight) list.scrollTo({ top: bottom - list.clientHeight + 12, behavior: 'smooth' });
        }
        fromThumb = false;
      };
      const go = (thumb) => {
        const sw = main.swiper;
        if (!sw || !thumb) return;
        const idx = Array.from(sw.slides).findIndex((sl) => sl.dataset.mediaId === thumb.dataset.mediaSubId);
        if (idx < 0) return;
        fromThumb = true;
        if (idx !== sw.activeIndex) sw.slideTo(idx, 0);
        else mark();
      };
      list.addEventListener('click', (e) => go(e.target.closest('.product__media-subitem')));
      outer.zwThumbGo = go; // usato dall'hover (initHover)
      const hook = () => {
        const sw = main.swiper;
        const sub = list.swiper;
        if (sub && !sub.__zwThumbs) {
          sub.__zwThumbs = true;
          sub.allowTouchMove = false;
        }
        if (sw && !sw.__zwThumbs) {
          sw.__zwThumbs = true;
          sw.on('slideChange', mark);
          mark();
        }
        sync();
      };
      [0, 300, 1000, 2000].forEach((t) => setTimeout(hook, t));
      window.addEventListener('resize', () => setTimeout(sync, 200));
    });
  };
  // desktop con mouse: hover sulla miniatura → quella foto nello slider grande;
  // hover sulla foto grande → zoom 2,2× nel suo riquadro che segue il cursore (click = modale)
  const initHover = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.product__outer--thumbs-aside').forEach((outer) => {
      if (outer.dataset.zwHover) return;
      outer.dataset.zwHover = '1';
      const main = outer.querySelector('.js-media-list');
      if (!main) return;
      let hoverT = null;
      outer.addEventListener('mouseover', (e) => {
        const thumb = e.target.closest('.product__media-subitem');
        if (!thumb || !outer.contains(thumb)) return;
        clearTimeout(hoverT);
        hoverT = setTimeout(() => {
          // stessa strada del click (initThumbs): cambio foto di colpo, la colonna resta ferma
          const col = thumb.closest('.product__media-sublist-outer');
          if (col && col.zwThumbGo) col.zwThumbGo(thumb);
        }, 80);
      });
      const ZOOM = 2.2;
      main.addEventListener('mousemove', (e) => {
        if (!window.matchMedia('(min-width: 1200px)').matches) return;
        const item = e.target.closest('.product__media-item');
        if (!item || item.classList.contains('product__media-item--full')) return;
        const box = item.querySelector('.product__media');
        const img = box && box.querySelector('img');
        if (!img) return;
        const r = box.getBoundingClientRect();
        const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
        const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = `scale(${ZOOM})`;
        item.classList.add('is-zooming');
      });
      main.addEventListener('mouseleave', () => {
        main.querySelectorAll('.product__media-item.is-zooming').forEach((item) => {
          item.classList.remove('is-zooming');
          const img = item.querySelector('.product__media img');
          if (img) img.style.transform = '';
        });
      });
      // cambio slide (frecce, miniature): azzera lo zoom della slide che esce
      const resetAll = () => main.querySelectorAll('.product__media img').forEach((img) => { img.style.transform = ''; img.closest('.product__media-item')?.classList.remove('is-zooming'); });
      [500, 1500].forEach((t) => setTimeout(() => {
        const sw = main.swiper;
        if (!sw || sw.__zwZoom) return;
        sw.__zwZoom = true;
        sw.on('slideChange', resetAll);
        // cambio foto istantaneo anche da frecce e click sulle miniature (Zalando): niente slide orizzontale
        sw.params.speed = 0;
      }, t));
    });
  };
  // thumbs_aside sotto i 1200: contatore "1 / 4" sullo slider principale (miniature nascoste dal CSS)
  const initCounter = () => {
    document.querySelectorAll('.product__outer--thumbs-aside .product__media-wrapper').forEach((wrap) => {
      if (wrap.dataset.zwCounter) return;
      const list = wrap.querySelector('.js-media-list');
      if (!list) return;
      const total = list.querySelectorAll('.product__media-item').length;
      if (total < 2) return;
      wrap.dataset.zwCounter = '1';
      const counter = document.createElement('div');
      counter.className = 'zw-gallery__counter';
      counter.setAttribute('aria-live', 'polite');
      wrap.appendChild(counter);
      const update = () => {
        const sw = list.swiper;
        counter.textContent = `${(sw ? sw.realIndex || sw.activeIndex : 0) + 1} / ${total}`;
      };
      update();
      [500, 1500].forEach((t) => setTimeout(() => {
        const sw = list.swiper;
        if (sw && !sw.__zwCounter) {
          sw.__zwCounter = true;
          sw.on('slideChange', update);
          // a due colonne (da 900): cambio foto istantaneo, niente scorrimento (anche su tablet,
          // dove initHover non gira perche' non c'e' il mouse)
          if (window.matchMedia('(min-width: 900px)').matches) sw.params.speed = 0;
          // sotto i 900 tutte le foto alte uguali (CSS): niente autoHeight del tema
          if (window.matchMedia('(max-width: 899px)').matches) {
            sw.params.autoHeight = false;
            if (sw.originalParams) sw.originalParams.autoHeight = false;
            sw.wrapperEl.style.height = '';
            sw.update();
          }
          update();
        }
      }, t));
    });
  };
  // viewer (modale del tema), sotto i 1200: contatore "1 / 5" nella barra in basso
  const initModalCounter = () => {
    document.querySelectorAll('.product-media-modal').forEach((modal) => {
      if (modal.dataset.zwCounter) return;
      const list = modal.querySelector('.js-popup-slider');
      const nav = modal.querySelector('.product__slider-nav');
      if (!list || !nav) return;
      const total = list.querySelectorAll('.swiper-slide').length;
      modal.dataset.zwCounter = '1';
      const counter = document.createElement('div');
      counter.className = 'zw-gallery__counter zw-gallery__counter--modal';
      counter.setAttribute('aria-live', 'polite');
      nav.insertAdjacentElement('afterbegin', counter);
      const update = () => {
        const sw = list.swiper;
        counter.textContent = `${(sw ? sw.activeIndex : 0) + 1} / ${total}`;
      };
      update();
      [500, 1500].forEach((t) => setTimeout(() => {
        const sw = list.swiper;
        if (sw && !sw.__zwCounter) {
          sw.__zwCounter = true;
          sw.on('slideChange', update);
          update();
        }
      }, t));
    });
  };
  // viewer, da 900px: miniature a sinistra come in scheda (thumbs_aside). Costruite dalle
  // slide del viewer stesso, cosi' ordine e indici combaciano sempre; click = slideTo.
  // Sotto i 900 sono nascoste dal CSS (li' c'e' la barra "1 / 5" in basso).
  const initModalThumbs = () => {
    document.querySelectorAll('.product-media-modal').forEach((modal) => {
      if (modal.dataset.zwThumbs) return;
      const list = modal.querySelector('.js-popup-slider');
      const dialog = modal.querySelector('.product-media-modal__dialog');
      if (!list || !dialog) return;
      const slides = list.querySelectorAll('.swiper-wrapper > .swiper-slide');
      if (slides.length < 2) return;
      modal.dataset.zwThumbs = '1';
      const rail = document.createElement('div');
      rail.className = 'zw-modal-thumbs';
      slides.forEach((slide, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'zw-modal-thumbs__item';
        btn.setAttribute('aria-label', `${i + 1} / ${slides.length}`);
        const src = slide.querySelector('img');
        if (src && (src.getAttribute('src') || '').length) {
          const img = document.createElement('img');
          // stessa foto del CDN Shopify, in piccolo
          try {
            const u = new URL(src.getAttribute('src'), location.href);
            u.searchParams.set('width', '200');
            img.src = u.toString();
          } catch (e) { img.src = src.getAttribute('src'); }
          img.alt = '';
          img.loading = 'lazy';
          img.width = 84;
          img.height = 112;
          btn.appendChild(img);
        } else {
          btn.classList.add('is-media');
          btn.textContent = '\u25B6'; // video o 3D: niente foto da mostrare
        }
        // click, e su desktop anche il passaggio del mouse (come le miniature della scheda).
        // A foto ingrandita resta ingrandita: il tema toglie .zoom a ogni cambio slide, qui si rimette.
        const go = () => {
          const sw = list.swiper;
          if (!sw || sw.activeIndex === i) return;
          const zoomed = list.classList.contains('zoom');
          sw.slideTo(i, 0);
          if (zoomed) requestAnimationFrame(() => list.classList.add('zoom'));
        };
        btn.addEventListener('click', go);
        if (window.matchMedia('(hover: hover)').matches) btn.addEventListener('mouseenter', go);
        rail.appendChild(btn);
      });
      dialog.insertBefore(rail, list);
      // la colonna restringe lo slider dopo che Swiper l'ha misurato a tutta larghezza
      if (list.swiper) list.swiper.update();
      const items = rail.querySelectorAll('.zw-modal-thumbs__item');
      const mark = () => {
        const a = list.swiper ? list.swiper.activeIndex : 0;
        items.forEach((b, i) => b.classList.toggle('is-active', i === a));
        const cur = items[a];
        // solo a viewer aperto: chiuso, scrollIntoView potrebbe far saltare la pagina
        if (cur && modal.hasAttribute('open')) cur.scrollIntoView({ block: 'nearest' });
      };
      mark();
      [500, 1500].forEach((t) => setTimeout(() => {
        const sw = list.swiper;
        if (sw && !sw.__zwThumbs) {
          sw.__zwThumbs = true;
          sw.update();
          sw.on('slideChange', mark);
          mark();
        }
      }, t));
    });
  };
  // zoom del viewer: main-product.js mette/toglie .zoom al click sulla foto; qui la posizione.
  // La foto ingrandita (3x desktop, 2,5x mobile, mai meno di quanto copre lo slider) segue il
  // puntatore: puntatore a sinistra = bordo sinistro della foto a 40px dal bordo dello slider, a
  // destra idem, in mezzo in proporzione. Stesso calcolo per mouse e dito. Transform inline !important: batte le regole di zoom del tema e le nostre.
  // Al primo zoom la foto chiede una versione piu' grande allo srcset (il tema ha fino a 4096px).
  // Su touch, a foto ingrandita lo swipe dello slider e' sospeso: il dito sposta lo zoom.
  const ZOOM = 2.5;
  const ZOOM_DESKTOP = 3;
  const ZOOM_EDGE = 40;
  const ZOOM_EDGE_MOBILE = 16;
  const initModalZoom = () => {
    document.querySelectorAll('.product-media-modal__content').forEach((box) => {
      if (box.dataset.zwZoom) return;
      box.dataset.zwZoom = '1';
      let last = null;
      const clear = () => {
        box.querySelectorAll('.js-image-zoom').forEach((img) => {
          img.style.removeProperty('transform');
          img.style.removeProperty('transform-origin');
        });
      };
      const place = (x0, y0) => {
        if (!box.classList.contains('zoom')) return;
        const slide = box.querySelector('.swiper-slide-active');
        const img = slide && slide.querySelector('.js-image-zoom');
        if (!img || !img.offsetWidth || !img.offsetHeight) return;
        last = [x0, y0];
        const r = slide.getBoundingClientRect();
        const sw = slide.clientWidth;
        const sh = slide.clientHeight;
        const w = img.offsetWidth;
        const h = img.offsetHeight;
        // 3x su desktop (3,6 era troppo vicino), 2,5x su mobile; mai meno di quanto copre lo slider
        const z = window.matchMedia('(min-width: 900px)').matches ? ZOOM_DESKTOP : ZOOM;
        const s = Math.max(z, sw / w, sh / h);
        const px = Math.min(1, Math.max(0, (x0 - r.left) / sw));
        const py = Math.min(1, Math.max(0, (y0 - r.top) / sh));
        // posizione finale della foto nello slider, poi traslazione dal suo posto senza transform.
        // ZOOM_EDGE: col puntatore a un bordo la foto si ferma a 40px dal bordo, 16px su mobile
        // (come i margini della card a riposo), cosi' si vede il bordo della foto e lo scorrimento e' piu' morbido
        const m = window.matchMedia('(min-width: 900px)').matches ? ZOOM_EDGE : ZOOM_EDGE_MOBILE;
        const tx = m + (sw - 2 * m - w * s) * px - img.offsetLeft;
        const ty = m + (sh - 2 * m - h * s) * py - img.offsetTop;
        img.style.setProperty('transform-origin', '0 0', 'important');
        img.style.setProperty('transform', `translate(${tx}px, ${ty}px) scale(${s})`, 'important');
        if (!img.dataset.zwBig) {
          img.dataset.zwBig = '1';
          img.sizes = '250vw';
        }
      };
      const sync = () => {
        // .zoom cambia dopo il click di main-product.js e ai cambi di foto: si legge al frame dopo
        requestAnimationFrame(() => {
          const on = box.classList.contains('zoom');
          if (box.swiper) box.swiper.allowTouchMove = !on;
          clear();
          if (on && last) place(last[0], last[1]);
        });
      };
      box.addEventListener('mousemove', (e) => place(e.clientX, e.clientY));
      box.addEventListener('click', (e) => { last = [e.clientX, e.clientY]; sync(); });
      box.addEventListener('touchmove', (e) => {
        if (!box.classList.contains('zoom') || e.touches.length !== 1) return;
        e.preventDefault();
        place(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: false });
      new MutationObserver(sync).observe(box, { attributes: true, attributeFilter: ['class'] });
    });
  };
  const initAll = () => {
    init();
    initThumbs();
    initHover();
    initCounter();
    initModalCounter();
    initModalThumbs();
    initModalZoom();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
